module.exports = __webpack_public_path__ + "static/media/main29.416127fe.png";